export const isEmpty = (value) => {
    if (value) {
        return false;
    }
    else {
        return value === undefined || value === null || isNaN(value);
    }
};
